import { Search, VisibilityRounded,CloseRounded as CloseIcon, Edit, SaveAltOutlined } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Autocomplete, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { CustomAutoComplete, DatePickerInputWithLabel, InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType, FormActions } from "../../../utils/constants";
import Checkbox from '@mui/material/Checkbox';
import { ModalFormGenerador } from "../../../components/form/ModalForm";
import * as yup from "yup";















const schemas = {
  "rqs_compras":yup.object({
    fecha_entrega: yup.string().required(),
    ciudad_destino:yup.string().required()
  })
  
}




const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestroDocumentos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [modalConfig,setModalConfig] = useState({});
  const [downloadSelected,setDownloadSelected] = useState("");
  const [maestros,setMaestros] = useState({});



    useEffect(()=>{

    


    },[]);


    const exportList = [
      {
        key:"rqs_compras",
        title:"RQS VS COMPRAS",
        descripcion:"Descarga el listado de RQS del municipio y las compras realizadas con ese destino",

      }
    ];


    useEffect(()=>{
  
      loadProducts();
    },[filterSearchPagination]);
    const loadProducts =  async (loading=true)=>{
      setMaestros([]);
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
     let {data:{value}} = await AxiosInstance.get("maestros/get-maestro-descargas");
     setMaestros(value);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const onCloseModalDetalle = ()=>{
      setIsVisibleModalDetalle(false);
    }
    const onChangeCheckBox = (evt,cod)=>{
      let newDataSet = [...dataSetProdctos];
      let indexItem = newDataSet.findIndex( item=>item.cod === cod );
      if ( indexItem !== -1){
        newDataSet[indexItem].ind_req_sobrecosto = newDataSet[indexItem].ind_req_sobrecosto === 1?0:1;
        setDataSetProductos(newDataSet);
      }
      console.log({evt:evt.target.value,cod});
    }
    const onSaveChangeItem = async(action,payload)=>{
         console.log({
          action,
          payload
         });
         onDownloadData(payload);
    }
  
    const onSelectDownload = (key)=>{

      setDownloadSelected(key);
      setIsVisibleModalDetalle(true);

    }

    const onDownloadData = (payload)=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      AxiosInstance.post(`maestros/documentos/descargar-documentos`,{
        ...payload,
        fecha_entrega:dayjs( payload.fecha_entrega ).format(DateFormatString)
      })
      .then(({data})=>{
       
        let element = document.createElement("a");
        element.style.display = 'none';
        element.href = `data:${data.value.type};base64,${data.value.base_64}`;
        element.download =  data.value.name_file;
       // document.body.appendChild(element);
        element.click();
       // document.body.removeChild(element); 
      }).catch(err=>{
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error de consulta documento",
            message: "Se ha presentado un error consultando el documento",
            type: DialogType.informativo,
            isVisible: true
          }
        });
      }).finally(()=>{
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });
    }



    const configInputs =  {
      entityValues:{
        ciudad_destino:null,
        fecha_entrega:dayjs()
      },
      titleModal: "Descargar Documento",
      buttomsAction: [
         
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Descargar",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"ciudad_destino",
          keyValue:"ciudad_destino",
          label:"Centro de operacion",
          component:SelectInputWithLabel,
          inputProps:{
          
            type:"text",
            size:"small",
            items:maestros.municipios || []
            
          }
        },
        {
          key:"fecha_entrega",
          keyValue:"fecha_entrega",
          label:"Fecha de entrega",
          component:DatePickerInputWithLabel,
          responsiveSize:6,
          inputProps:{
            type:"date",
            size:"small",
           }
        },
        
        
      ],
      arrayInputs:[]
    };

  
    return (<>
{
      isVisibleModalDetalle && downloadSelected &&
      <ModalFormGenerador
       
        isVisible={isVisibleModalDetalle}
      
        schemaValidator={schemas[downloadSelected]}
        {
        ...configInputs
        }
        onSendForm={onSaveChangeItem}
        typeAction={FormActions.AGREGAR}
      />
    } 
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={12} >
              <Typography variant="h2" >
                  Descarga de documentos
              </Typography>

        </Grid>
        {
          exportList.map( expor_item=><Grid item sm={6} xs={6} md={3} >

            <Card key={expor_item.key} >
              <CardContent>
                <Typography variant="subtitle2" >{expor_item.title}</Typography>
                <Typography variant="body1" >{expor_item.descripcion}</Typography>
                <Button onClick={e=>onSelectDownload(expor_item.key)} variant="contained" color="primary" >Descargar</Button>
              </CardContent>
            </Card>
  
          </Grid> )
        }
        
    </Grid>
    </>)

}